import { cronosClient } from "@/config/client"

export type UserCategory = "work" | "study" | "wellness" | "recreation" | "study_time"

export interface Event {
  id: number
  days: number[]
  description: string
  category: UserCategory
  start_hour: string
  end_hour: string
}

interface Payload {
  nickname: string
  hobbies: string[]
  events: Event[]
}

export function create(payload: Payload) {
  return cronosClient.post<void, Payload>("/v1/onboarding/flush", payload)
}
